import React from 'react';

const WarmingSystemFeatures = () => {
  return (
    <div
      className="features-container"
      style={{
        margin: '30px auto',
        padding: '20px',
        maxWidth: '900px',
        backgroundColor: '#f8f9fa', // light background
        borderRadius: '10px',
        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
      }}
    >
      <h2
        style={{
          textAlign: 'center',
          marginBottom: '20px',
          color: '#007BFF', // Blue title color
        }}
      >
        Warming System Features
      </h2>

      <div
        style={{
          display: 'grid',
          gridTemplateColumns: '1fr 1fr',
          gap: '20px',
          // Adding responsiveness
          gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))', // Makes it responsive
        }}
      >
        {/* Feature 1 */}
        <div
          style={{
            backgroundColor: '#ffffff',
            padding: '20px',
            borderRadius: '8px',
            boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
          }}
        >
          <h3 style={{ color: '#007BFF' }}>Volume & Alarm Control</h3>
          <ul style={{ paddingLeft: '20px' }}>
            <li>
              <strong>Adjustable in 8 Levels:</strong> Both volume and alarm volume can be adjusted in 8 levels.
            </li>
            <li>
              <strong>Mute Function:</strong> The volume can be muted for 2 minutes, providing flexibility during use.
            </li>
          </ul>
        </div>

        {/* Feature 2 */}
        <div
          style={{
            backgroundColor: '#ffffff',
            padding: '20px',
            borderRadius: '8px',
            boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
          }}
        >
          <h3 style={{ color: '#007BFF' }}>Over-Temperature Protection</h3>
          <ul style={{ paddingLeft: '20px' }}>
            <li>
              <strong>Double Protection:</strong> The system has double protection through both software and hardware.
            </li>
            <li>
              <strong>Real-Time Monitoring:</strong> The temperature of the heater is monitored in real-time, and if it exceeds 60°C, the system triggers hardware-based power-off protection to prevent overheating.
            </li>
          </ul>
        </div>
      </div>

      <div
        style={{
          display: 'grid',
          gridTemplateColumns: '1fr 1fr',
          gap: '20px',
          marginTop: '20px',
          // Adding responsiveness
          gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))', // Makes it responsive
        }}
      >
        {/* Feature 3 */}
        <div
          style={{
            backgroundColor: '#ffffff',
            padding: '20px',
            borderRadius: '8px',
            boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
          }}
        >
          <h3 style={{ color: '#007BFF' }}>Double Air Purification Function</h3>
          <ul style={{ paddingLeft: '20px' }}>
            <li>
              <strong>Plasma Air Purification:</strong> The system uses plasma air purification for cleaner air.
            </li>
            <li>
              <strong>Filter Grade:</strong> Equipped with an EN779 grade HEPA filter for effective air filtration.
            </li>
          </ul>
        </div>

        {/* Feature 4 */}
        <div
          style={{
            backgroundColor: '#ffffff',
            padding: '20px',
            borderRadius: '8px',
            boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
          }}
        >
          <h3 style={{ color: '#007BFF' }}>Self-Check & Alarm Function</h3>
          <ul style={{ paddingLeft: '20px' }}>
            <li>
              <strong>Sound & Light Alarm:</strong> The system has a built-in alarm for high temperature, low temperature, heater issues, fan abnormalities, and more.
            </li>
            <li>
              <strong>Machine Self-Check:</strong> The system performs real-time self-check during power-on and the warming blanket process.
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default WarmingSystemFeatures;
